// Call rudderstack api
import {
  RudderAnalytics,
  ApiCallback,
  ApiObject,
  ApiOptions,
  IdentifyTraits,
  LoadOptions,
} from '@rudderstack/analytics-js';
import {ITrackingTransformationInput} from '../types';

const createRudderTracker = ({
  dataPlaneUrl,
  writeKey,
  serviceName,
  loadOptions,
}: {
  dataPlaneUrl: string;
  writeKey: string;
  serviceName: string;
  loadOptions?: LoadOptions;
}) => {
  const context = {
    eventClient: {
      name: 'tracker-js',
      version: __VERSION__,
    },
    service: {
      name: serviceName,
    },
  };

  let rudderAnalytics = window.rudderanalytics;
  if (!rudderAnalytics) {
    rudderAnalytics = new RudderAnalytics();
    rudderAnalytics.load(writeKey, dataPlaneUrl, loadOptions);
  }

  return {
    trackFromLegacy: (eventName: string, legacyProperties: ITrackingTransformationInput): void => {
      const transformedProperties = {
        tracking_id: legacyProperties.trackingId,
        event_name: eventName,
        legacy_event: JSON.stringify(legacyProperties),
        category: legacyProperties?.properties?.category || null,
        sub_category: legacyProperties?.properties?.sub_category || null,
      };

      const apiOptions = {
        context,
      };

      return rudderAnalytics.track('ungoverned', transformedProperties, apiOptions);
    },

    trackPage: (
      category: string,
      pageName: string,
      pageProperties?: ApiObject,
      apiOptions?: ApiOptions
    ): void => {
      const transformedApiOptions = {
        context,
        ...apiOptions,
      };

      return rudderAnalytics.page(category, pageName, pageProperties, transformedApiOptions);
    },

    trackIdentify: (
      userId: string,
      traits?: ApiObject,
      apiOptions?: ApiOptions,
      callback?: ApiCallback
    ): void => {
      const transformedApiOptions = {
        context,
        ...apiOptions,
      };

      return rudderAnalytics.identify(
        userId,
        traits as IdentifyTraits,
        transformedApiOptions,
        callback
      );
    },

    track: (
      eventName: string,
      properties?: ApiObject,
      apiOptions?: ApiOptions,
      callback?: ApiCallback
    ): void => {
      const transformedApiOptions = {
        context,
        ...apiOptions,
      };

      return rudderAnalytics.track(eventName, properties, transformedApiOptions, callback);
    },
  };
};

export default createRudderTracker;
